import Identity from './Identity';
import MapValue from './MapValue';
import {Value} from './Value';

export class Entity<ID extends Identity<any>, T extends Record<string, Value<any>>> extends MapValue<{ id: ID } & T> {
  get id() {
    return this.value.id.id;
  }
}